import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-session-load',
  standalone: true,
  imports: [ProgressSpinnerModule, CommonModule],
  template: `
    <div style="display: flex; justify-content: center; align-items: center; height: 100vh; flex-direction: column; gap: 16px;">
      <p-progressSpinner></p-progressSpinner>
      <span style="color: #004F71; font-weight: 600;">Loading Diaspora Wallet...</span>
    </div>
  `
})
export class SessionLoadComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      this.router.navigateByUrl('/amount');
    }
  }
}
